$(".js-link-show-popup").on("click", function() {
  $(".popup").addClass("show");
});

$(".js-link-hide-popup").on("click", function () {
  $(".popup").removeClass("show");
});


// WEBPACK FOOTER //
// ./skippair.github.io/assets/js/components/_popup.js